<div class="d-flex reverse-row d-print-none px-5 p-1 mb-3">
  <div class="row">
    <div class="col p-1">
      <button (click)="impressaoJS()" class="btn btn-theme btn-sm btn-icon ">
        <i class="mdi mdi-printer"></i>
        <span>Impressão rápida</span>
      </button>
      <!-- <p class="aviso">Nova impressão de PDF</p> -->
    </div>

    <div class="col p-1">
      <!--button (click)="downloadFotos()" class="btn btn-theme btn-sm btn-icon">
        <i class="mdi mdi-download"></i>
        <span>Download Fotos</span>
      </button -->
      <a [href]="urlDownloadFotos" rel="noopener noreferrer" target="_blank" download="" class="btn btn-theme btn-sm btn-icon">
        <i class="mdi mdi-download"></i>
        <span>Download Fotos</span>
      </a>
    </div>

    <div class="col p-1">
      <button (click)="printPdf()" rel="noopener noreferrer" target="_blank" download="" class="btn btn-theme btn-sm btn-icon">
        <i class="mdi mdi-printer"></i>
        <span>Impressão</span>
      </button>
    </div>
  </div>
</div>

<app-header-relatorio-laudo id="header" *ngIf="cabecalho" [consulta]="cabecalho"></app-header-relatorio-laudo>

<div class="resultado-consulta-container px-2 p-1">
  <!-- <app-relatorio-laudo-resumo [template]="{label: 'RESUMO', status: null, elements: [
  {status: 1, value: 'VALOR DO ITEM', label: 'ESTRUTURA'},
  {status: 3, value: 'VALOR DO ITEM', label: 'PINTURA'},
  {status: 5, value: 'VALOR DO ITEM', label: 'IDENTIFICAÇÃO'}
  ]}"></app-relatorio-laudo-resumo> -->


  <!-- <app-relatorio-laudo-resumo-lista [template]="{label: 'RESUMO', status: null, elements: [
  {status: 1, value: 'VALOR DO ITEM', label: 'ESTRUTURA'},
  {status: 3, value: 'VALOR DO ITEM', label: 'PINTURA'},
  {status: 5, value: 'VALOR DO ITEM', label: 'IDENTIFICAÇÃO'},
  {status: 1, value: 'VALOR DO ITEM', label: 'ESTRUTURA'},
  {status: 3, value: 'VALOR DO ITEM', label: 'PINTURA'},
  {status: 5, value: 'VALOR DO ITEM', label: 'IDENTIFICAÇÃO'},
  {status: 1, value: 'VALOR DO ITEM', label: 'ESTRUTURA'},
  {status: 3, value: 'VALOR DO ITEM', label: 'PINTURA'},
  {status: 5, value: 'VALOR DO ITEM', label: 'IDENTIFICAÇÃO'}
  ]}"></app-relatorio-laudo-resumo-lista> -->
</div>


<div *ngFor="let t of template" class="resultado-consulta-container px-sm-2 px-md-3 px-xl-5">
  <ng-container [ngSwitch]="t.name">

    <app-relatorio-laudo-resumo *ngSwitchCase="'resumo'" [template]="t"></app-relatorio-laudo-resumo>

    <app-relatorio-laudo-resumo-lista *ngSwitchCase="'resumo-lista'" [template]="t"></app-relatorio-laudo-resumo-lista>

    <!-- <app-relatorio-laudo-resumo-lista *ngSwitchCase="'resumo-lista'"></app-relatorio-laudo-resumo-lista> -->

    <app-relatorio-laudo-dados-veiculo *ngSwitchCase="'dadosVeiculo'" [template]="t"></app-relatorio-laudo-dados-veiculo>

    <app-relatorio-laudo-proprietario *ngSwitchCase="'proprietario'" [template]="t"></app-relatorio-laudo-proprietario>

    <app-relatorio-laudo-vidros *ngSwitchCase="'vidros'" [template]="t"></app-relatorio-laudo-vidros>

    <app-relatorio-laudo-veiculo *ngSwitchCase="'veiculo'" [template]="t"></app-relatorio-laudo-veiculo>

    <app-relatorio-laudo-pintura *ngSwitchCase="'analisePintura'" [template]="t"></app-relatorio-laudo-pintura>

    <app-relatorio-laudo-padrao *ngSwitchDefault [template]="t"></app-relatorio-laudo-padrao>

  </ng-container>

</div>

<ng-container class="header-consulta" *ngIf="consulta">

  <div class="header-consulta">
    <app-header-consulta [dadosConsulta]="consulta"></app-header-consulta>
  </div>
  <app-consulta-resultado [dadosConsulta]="consulta"></app-consulta-resultado>

</ng-container>

<div class="resultado-consulta-container px-sm-2 px-md-3 px-xl-5" *ngIf="openInfo">

  <app-informativo></app-informativo>


</div>
